export const PARTNER_BRAND_OPTIONS = [
  { text: '中粮', value: 'ZHONGLIANG' },
  { text: '新希望', value: 'XINXIWANG' },
  { text: '嘉吉', value: 'JIAJI' },
  { text: '海大', value: 'HAIDA' },
  { text: '英联', value: 'YINGLIAN' },
]

/** 友商品牌主色（模板 van-button / tabs 等） */
export const PARTNER_THEME_COLOR = '#2d7a3d'

export const PARTNER_BRAND_MAP = PARTNER_BRAND_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item.text
  return acc
}, {})

export const TRADE_STATUS_OPTIONS = [
  { text: '意向客户', value: 1 },
  { text: '合作客户', value: 2 },
]

export const BREED_TYPE_OPTIONS = ['鸡', '鸭', '鹅', '猪', '牛', '羊', '其他']

export const HEAD_BREED_TYPES = ['猪', '牛', '羊']

export function getBreedScaleUnit(breedType) {
  return HEAD_BREED_TYPES.includes(breedType) ? '头' : '只'
}

export const LOG_TYPE_OPTIONS = [
  { name: 'check', title: '查重记录' },
  { name: 'add', title: '添加记录' },
  { name: 'invalid', title: '失效记录' },
  { name: 'edit', title: '修改记录' },
]

export function resolveLogCategory(type) {
  const text = String(type || '').toLowerCase()
  if (text === 'check' || text.includes('查重')) return 'check'
  if (text === 'add' || text.includes('添加')) return 'add'
  if (text === 'invalid' || text.includes('失效')) return 'invalid'
  if (text === 'edit' || text.includes('修改')) return 'edit'
  return 'add'
}

export function getTradeStatusLabel(tradeStatus, tradeStatusName) {
  if (tradeStatusName) return tradeStatusName
  const item = TRADE_STATUS_OPTIONS.find((option) => option.value === tradeStatus)
  return item ? item.text : ''
}

export const PARTNER_PAGE_SIZE = 10

export function isPartnerRoute(path) {
  const p = path || ''
  return p === '/partner' || p.startsWith('/partner-')
}

/** 企微 CRM 只读模式底部 Tab */
export const PARTNER_WXWORK_TAB_NAMES = ['partner-customerList', 'partner-check', 'partner-logList']

/** 企微 CRM 模式下需拦截的写操作路由 */
export function isPartnerWriteRoute(route) {
  const name = route?.name
  if (name === 'partner-register') return true
  if (name === 'partner-customerEdit') {
    if (!route.params?.id) return true
    if (route.query?.readonly === '1') return false
    return true
  }
  return false
}
